import React from 'react';
import '../../../App.css';

const LoadingAnimation = () => {return <div className="loading">
            <div className="loading-anim"/>
        </div>};

export default LoadingAnimation;
